import { useGlobalQueryString } from './useGlobalFilter';
import { useMemo } from 'react';

interface service {
  id: number;
}

export function useFiltersForFunction(
  aggregatedEndpoint: number | undefined,
  services: service[] | undefined,
  tags?: Record<string, string>,
) {
  const globalFilters = useGlobalQueryString();
  const filtersForFunction = useMemo(() => {
    const updatedSearchParams = new URLSearchParams();

    if (aggregatedEndpoint && services?.length === 1) {
      updatedSearchParams.set('flow', aggregatedEndpoint.toString());
      updatedSearchParams.set('service', services[0].id.toString());
    }
    if (tags && Object.keys(tags).length > 0)
      updatedSearchParams.set('tags', Object.entries(tags).map(([key, value]) => `${key}-${value}`).join(','));
    const updatedFilters = [globalFilters, updatedSearchParams.toString()].filter(Boolean).join('&');
    return updatedFilters;
  }, [aggregatedEndpoint, globalFilters, services]);
  return filtersForFunction;
}
